// A list with a details panel: side by side when there is room, otherwise the
// panel slides in over the page from the right.
import { useEffect, useRef, useState } from "react";
import "./Lists.css";

const SPLIT_WIDTH = 1100;

function useWidth(ref) {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    const measure = () => setWidth(element.clientWidth);
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);
  return width;
}

/** panel: null, or (mode: "split" | "sheet") => element */
export default function SplitView({ panel, children }) {
  const ref = useRef(null);
  const width = useWidth(ref);
  const split = Boolean(panel) && width >= SPLIT_WIDTH;
  return <div ref={ref} className={`sa-split${split ? " has-panel" : ""}`}>
    <div className="sa-split-main">{children}</div>
    {panel && panel(split ? "split" : "sheet")}
  </div>;
}
